import { Injectable } from '@angular/core';
import * as PermissionsActions from '../actions/permissions.actions';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, switchMap, tap } from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@app/store';
import { PermissionsService } from '@app/modules/auth';
import { Perms } from '@app/store/permissions/models/permissions.models';
import { selectAllPermissions } from '@app/store/permissions/selectors/permissions.selectors';
import { UserProfile } from '@app/modules/auth/models/core-user-api.model';
import { DataDogService } from '@app/services/data-dog.service';

@Injectable()
export class PermissionsEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private permissionsService: PermissionsService,
    private dataDog: DataDogService
  ) {}

  loadPermissions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PermissionsActions.loadPermissions),
      tap(val => this.dataDog.addRumTiming('load_permissions_request_started')),
      switchMap(_ => {
        return combineLatest([
          this.permissionsService.hasPermission(Perms.READ_COMPANY),
          this.permissionsService.getUserProfiles(),
          this.permissionsService.isZonarUser(),
          // this.permissionsService.getCompaniesForPerm('read', 'company'),
          this.permissionsService.getCompanyMap(),
          this.permissionsService.getDivisionsMap(),
          //this.permissionsService.getLegacyAccountsForPerm('read', 'company'),
          //this.permissionsService.getLegacyLocationsForPerm('read', 'company'),
          this.permissionsService.getRequestStartTime()
        ]);
      }),
      mergeMap(
        ([readCompany, userProfiles, isZonarUser, companyMap, divisionMap, requestStartTime = 0]: [
          boolean,
          [UserProfile],
          boolean,
          //[Company],
          any,
          any,
          //[Division],
          //[Division],
          number
        ]) => {
          this.dataDog.addRumAction('load_permissions_request_time', {
            loadTime: Date.now() - requestStartTime
          });
          this.dataDog.addRumTiming('load_permissions_request_success');
          const companyIds = Array.from(new Set(userProfiles.map(userProfile => userProfile.companyId)));
          const readCompanies = isZonarUser || companyIds.length > 1;

          // TODO set divisions ?
          return of(
            PermissionsActions.savePermissions({
              readCompany,
              readCompanies,
              isZonarUser,
              // companies: [],
              companies: companyMap ? Object.values(companyMap) : [],
              divisions: divisionMap ? Object.values(divisionMap) : [],
              // locations: [],
              requestStartTime
            })
          );
        }
      )
    );
  });

  loadEntitiesOnSavePerms$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PermissionsActions.savePermissions),
      concatLatestFrom(() => this.store.select(selectAllPermissions)),
      switchMap(([_, { isZonarUser, companies, divisions }]) => {
        // for zonar users both these properties should be []
        return of(
          PermissionsActions.saveEntities({
            companies: isZonarUser ? [] : companies,
            divisions: isZonarUser ? [] : divisions
          })
        );
      })
    )
  );
}
